import * as React from "react";
import { useState, useEffect } from "react";
import { useParams } from "react-router";
import { Field, Form, Formik } from "formik";
import * as Yup from "yup";
import toast from "react-hot-toast";
import axiosInstant from "../../api";
import config from "../../config";
import { useUser } from "../../hooks/useUser";
import { getBrandTeamEndpoint } from "../../api/endpoints";
import { MainContainer } from "../../components/ContentWrapper";
import { planLabel } from "../../utils/plans";

const UserSchema = Yup.object().shape({
  firstName: Yup.string(),
  lastName: Yup.string(),
  emailAddress: Yup.string(),
});

export default function MyProfile() {
  const { user } = useUser();
  const [proDetail, setProDetail] = useState(false);
  const [brands, setBrands] = useState([]);
  const [admin, setAdmin] = useState({});

  console.log("user", user);

  useEffect(() => {
    //get pros
    axiosInstant
      .get("/users/me", {})
      .then((response) => {
        setProDetail(response.data);
        if (response.data.brand) {
          setBrands(response.data.brand);
        }
      })
      .catch((error) => {});

    getBrandAdmin();
  }, []);

  const handleSaveChanges = (values, { setSubmitting }) => {
    setSubmitting(true);
    console.log(values);
    axiosInstant
      .patch(`${config.API_URL}/users/me`, values)
      .then((response) => {
        toast.success("Profile Informations Saved");
        setSubmitting(false);
      })
      .catch((error) => {
        toast.error("Profile edit error");
        setSubmitting(false);
      });
  };

  const formatRole = (role) => {
    role = role.toLowerCase();
    role = role.charAt(0).toUpperCase() + role.slice(1);
    role = role.replace(/_/g, " ");
    return role;
  };

  const getBrandAdmin = () => {
    if (user.brand?.length) {
      axiosInstant
        .get(getBrandTeamEndpoint(user.brand[0].id))
        .then((response) => {
          response.data.rows.forEach((member) => {
            if (member.usertype == "brand admin") {
              setAdmin(member);
            }
          });
        })
        .catch((response) => {
          // error
        });
    }
  };

  return (
    <Formik
      initialValues={{
        firstName: proDetail.firstName,
        lastName: proDetail.lastName,
        emailAddress: proDetail.emailAddress,
      }}
      validationSchema={UserSchema}
      enableReinitialize
      onSubmit={handleSaveChanges}
    >
      {({ isSubmitting, errors, touched }) => (
        <Form className="w-full">
          <h3 className="text-text-1 text-xl sm:text-3xl font-bold uppercase font-[CircularStd]">
            Profile
          </h3>
          <div className="flex flex-col sm:flex-row sm:justify-between gap-4 sm:gap-2">
            <div className="w-full sm:w-[49%]">
              <span className="text-base font-bold text-left block mb-4 mt-3">
                First Name
              </span>
              <Field
                placeholder="First Name"
                name="firstName"
                type="text"
                className={`appearance-none text-sm border rounded w-full mb-0 p-4 rounded-xl text-text-1 leading-tight focus:outline-none focus:shadow-outline mb-3 ${
                  errors.firstName && touched.firstName
                    ? "border-error"
                    : "border-border-token"
                }`}
              />
              {errors.firstName && touched.firstName ? (
                <div className="text-left text-error text-xs font-bold mt-1 pl-5">
                  {errors.firstName}
                </div>
              ) : null}
            </div>
            <div className="w-full sm:w-[49%]">
              <span className="text-base font-bold text-left block mb-4 mt-3">
                Last Name
              </span>
              <Field
                placeholder="Last Name"
                name="lastName"
                type="text"
                className={`appearance-none text-sm border rounded w-full mb-0 p-4 rounded-xl text-text-1 leading-tight focus:outline-none focus:shadow-outline mb-3 ${
                  errors.lastName && touched.lastName
                    ? "border-error"
                    : "border-border-token"
                }`}
              />
              {errors.lastName && touched.lastName ? (
                <div className="text-left text-error text-xs font-bold mt-1 pl-5">
                  {errors.lastName}
                </div>
              ) : null}
            </div>
          </div>

          <div className="flex flex-col sm:flex-row sm:justify-between gap-4 sm:gap-2">
            <div className="w-full sm:w-[49%]">
              <span className="text-base font-bold text-left block mb-4 mt-3">
                Email
              </span>
              <Field
                placeholder="Email"
                name="emailAddress"
                type="text"
                className={`appearance-none text-sm border rounded w-full mb-0 p-4 rounded-xl text-text-1 leading-tight focus:outline-none focus:shadow-outline mb-3 ${
                  errors.emailAddress && touched.emailAddress
                    ? "border-error"
                    : "border-border-token"
                }`}
              />
              {errors.email && touched.emailAddress ? (
                <div className="text-left text-error text-xs font-bold mt-1 pl-5">
                  {errors.emailAddress}
                </div>
              ) : null}
            </div>
          </div>

          <div className="flex flex-col sm:flex-row sm:justify-between gap-4 sm:gap-2 mt-6 sm:mt-10">
            {brands.length > 0 && (
              <div className="w-full sm:w-[49%]">
                <span className="text-base font-bold text-left block mb-4 mt-3">
                  Brand
                </span>
                <div className="bg-surface-2 appearance-none text-sm border border-border-token rounded w-full mb-0 p-4 rounded-xl text-text-1 leading-tight focus:outline-none focus:shadow-outline mb-3">
                  {brands.map((brand) => brand.name).join(", ")}
                </div>
              </div>
            )}
            <div className="w-full sm:w-[49%]">
              <span className="text-base font-bold text-left block mb-4 mt-3">
                Role
              </span>
              <div className="bg-surface-2 appearance-none text-sm border border-border-token rounded w-full mb-0 p-4 rounded-xl text-text-1 leading-tight focus:outline-none focus:shadow-outline mb-3">
                {formatRole(user?.role?.name || user?.role || user?.usertype)}
              </div>
            </div>
          </div>

          <div className="flex flex-col sm:flex-row sm:justify-between gap-4 sm:gap-2 mt-6 sm:mt-10">
            <div className="w-full sm:w-[49%]">
              <span className="text-base font-bold text-left block mb-4 mt-3">
                Admin
              </span>
              <div className="bg-surface-2 appearance-none text-sm border border-border-token w-full p-4 rounded-xl text-text-1 leading-tight focus:outline-none focus:shadow-outline mb-3">
                {user?.role === "BRAND_ADMIN"
                  ? "You are the account admin."
                  : `${admin?.emailAddress || "No Admin."}`}
              </div>
            </div>
            {brands.length > 0 && (
              <div className="w-full sm:w-[49%]">
                <span className="text-base font-bold text-left block mb-4 mt-3">
                  Plan
                </span>
                {/* brands.plan (lib/brandPlans), not the legacy hardcoded
                    user.subscription that still keys the route tables. */}
                <div className="flex flex-col sm:flex-row sm:items-stretch gap-2 mb-3">
                  <div className="bg-surface-2 appearance-none text-sm border border-border-token w-full p-4 rounded-xl text-text-1 leading-tight focus:outline-none focus:shadow-outline">
                    {planLabel(brands[0].plan || "free")}
                  </div>
                  <a
                    href="https://thedesirecompany.com/home#home-page-contact"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="bg-accent text-white text-sm px-4 py-3 rounded-xl whitespace-nowrap flex items-center justify-center"
                  >
                    To upgrade, please contact sales
                  </a>
                </div>
              </div>
            )}
          </div>

          {/* <div className="bg-white rounded p-6 lg:p-4 block lg:flex pb-4 pt-0 mt-5">
                                        <div className="flex items-center pb-4">

                                            <h3 className="text-dark text-3xl font-bold uppercase font-[CircularStd]">Brand :</h3>
                                            <span className="text-base font-bold text-left block mb-4 mt-3">Brand:</span>

                                        </div>
                                        <p className="text-black text-2xl mr-1">
                                            { brands.map( brand => brand.name ).join( ', ' )}
                                        </p>
                                    </div> */}

          {/* <div className='bg-white rounded p-6 lg:p-4 block lg:flex pb-4 pt-0 mt-5'>
                                        Can't find what you're looking for,&nbsp;<Link className='text-blue-600' to='/settings' >Go to Settings</Link>
                                    </div> */}

          <button
            disabled={isSubmitting}
            className="bg-accent text-sm sm:text-base text-white mt-6 py-2.5 sm:py-3 px-4 sm:px-5 lg:px-10 w-full sm:w-auto rounded-xl focus:outline-none focus:shadow-outline"
            type="submit"
          >
            {isSubmitting ? "Saving..." : "Save changes"}
          </button>
        </Form>
      )}
    </Formik>
  );
}
